// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `footer{
  height: 387px;
  width: 100vw;
  top: 0;
  background-color: var(--color-secondary-white);
}

.styles_container__R34yi{
  width: var(--container-width-md);
  max-width: 1920px;
  margin-inline: auto ;
  display: flex;
  flex-wrap: wrap;
  column-gap: 10px;
  row-gap: 10px;
  justify-content: space-between;
  padding-top: 64px;
}

.styles_container__R34yi > div {
  margin: 0 auto;
}

.styles_container__R34yi > .styles_footLeft__ew5OZ{
  margin: 0%;
}

.styles_footLeft__ew5OZ{
  display: flex;
  flex-direction: column;
  width: 282px;
  row-gap: 25px;
  margin: none;
}

.styles_logo__YpvBc {
  width: 168px;
  height: 42px;
  cursor: pointer;
}

.styles_footLeft__ew5OZ > p {
  font-style: normal;
  font-weight: 390;
  font-size: 22px;
  line-height: 31px;
  color: var(--color-secondary-black);

}

.styles_authBtnGetStarted__d\\+XnK {
  width: 140px;
  height: 40px;
  border-radius: 8px;
  font-size: 18px;
  font-weight: 500;
  font-family: 'Brandon Grotesque';
  cursor: pointer;
  background: linear-gradient(90deg, var(--color-primary) 0%, var(--color-secundary) 100%);
  color: #fff;
}

.styles_list__J5zey{
  display: flex;
  flex-direction: column;
  row-gap: 6px;
  
}

.styles_list__J5zey > span {
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 31px;
  color: var(--color-primary-black);
}

.styles_list__J5zey  > ul {
  display: flex;
  flex-direction: column;
  font-size: 20px;
  row-gap: 6px;
  list-style: none;
}

.styles_textReserved__\\+52OF {
  margin-top: 50px;
  padding-bottom: 30px;
  font-weight: 450;
  font-size: 14px;
  line-height: 20.02px;
  color: #828282;
  text-align: center;
}

@media screen and (max-width: 1024px ){

  footer{
    height: auto;

  }
}

@media screen and (max-width: 820px ){

  .styles_list__J5zey{
    width: 161px;
    
  }
}


`, "",{"version":3,"sources":["webpack://./src/components/Footer/styles.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,MAAM;EACN,8CAA8C;AAChD;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mCAAmC;;AAErC;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,wFAAwF;EACxF,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;;AAEd;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE;IACE,YAAY;;EAEd;AACF;;AAEA;;EAEE;IACE,YAAY;;EAEd;AACF","sourcesContent":["footer{\n  height: 387px;\n  width: 100vw;\n  top: 0;\n  background-color: var(--color-secondary-white);\n}\n\n.container{\n  width: var(--container-width-md);\n  max-width: 1920px;\n  margin-inline: auto ;\n  display: flex;\n  flex-wrap: wrap;\n  column-gap: 10px;\n  row-gap: 10px;\n  justify-content: space-between;\n  padding-top: 64px;\n}\n\n.container > div {\n  margin: 0 auto;\n}\n\n.container > .footLeft{\n  margin: 0%;\n}\n\n.footLeft{\n  display: flex;\n  flex-direction: column;\n  width: 282px;\n  row-gap: 25px;\n  margin: none;\n}\n\n.logo {\n  width: 168px;\n  height: 42px;\n  cursor: pointer;\n}\n\n.footLeft > p {\n  font-style: normal;\n  font-weight: 390;\n  font-size: 22px;\n  line-height: 31px;\n  color: var(--color-secondary-black);\n\n}\n\n.authBtnGetStarted {\n  width: 140px;\n  height: 40px;\n  border-radius: 8px;\n  font-size: 18px;\n  font-weight: 500;\n  font-family: 'Brandon Grotesque';\n  cursor: pointer;\n  background: linear-gradient(90deg, var(--color-primary) 0%, var(--color-secundary) 100%);\n  color: #fff;\n}\n\n.list{\n  display: flex;\n  flex-direction: column;\n  row-gap: 6px;\n  \n}\n\n.list > span {\n  font-style: normal;\n  font-weight: bold;\n  font-size: 22px;\n  line-height: 31px;\n  color: var(--color-primary-black);\n}\n\n.list  > ul {\n  display: flex;\n  flex-direction: column;\n  font-size: 20px;\n  row-gap: 6px;\n  list-style: none;\n}\n\n.textReserved {\n  margin-top: 50px;\n  padding-bottom: 30px;\n  font-weight: 450;\n  font-size: 14px;\n  line-height: 20.02px;\n  color: #828282;\n  text-align: center;\n}\n\n@media screen and (max-width: 1024px ){\n\n  footer{\n    height: auto;\n\n  }\n}\n\n@media screen and (max-width: 820px ){\n\n  .list{\n    width: 161px;\n    \n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__R34yi`,
	"footLeft": `styles_footLeft__ew5OZ`,
	"logo": `styles_logo__YpvBc`,
	"authBtnGetStarted": `styles_authBtnGetStarted__d+XnK`,
	"list": `styles_list__J5zey`,
	"textReserved": `styles_textReserved__+52OF`
};
export default ___CSS_LOADER_EXPORT___;
